import type { Bounds } from 'wucdbm-exponential-slider'
import type { InputRangeTwoKnobbedValueFormatter } from '@/components/ui/inputs/range/input-range-two-knobbed-props.ts'
import type { InferDefaults } from '@/helpers/vue.ts'

export interface Props {
    modelValue: Bounds
    bounds: Bounds
    steps: number
    linearPercent: number
    maxLinear: number
    debounce?: number
    minLabel?: string
    maxLabel?: string
    valueFormatter?: InputRangeTwoKnobbedValueFormatter
}

export const defaults = {
    debounce: 0,
    minLabel: 'Min',
    maxLabel: 'Max',
    valueFormatter: undefined,
} as const satisfies InferDefaults<Props>
